module.exports = __webpack_public_path__ + "static/grafika2-b170670939b2c9a057854984beb66aaf.png";